// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VBtsJf {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  height: auto;
  box-sizing: border-box;
  background-color: var(--background-alt);
  overflow-x: hidden;
}

.aSNIHr {
  display: flex;
  min-height: 100%;
  height: auto;
  width: 100%;
  max-width: 100vw;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

@media (max-width: var(--grid-breakpoint-l)) {
  .aSNIHr {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DefaultLayout/DefaultLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".defaultLayout {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  height: auto;\n  box-sizing: border-box;\n  background-color: var(--background-alt);\n  overflow-x: hidden;\n}\n\n.defaultLayoutContent {\n  display: flex;\n  min-height: 100%;\n  height: auto;\n  width: 100%;\n  max-width: 100vw;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n@media (max-width: var(--grid-breakpoint-l)) {\n  .defaultLayoutContent {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultLayout": `VBtsJf`,
	"defaultLayoutContent": `aSNIHr`
};
module.exports = ___CSS_LOADER_EXPORT___;
